import { defineZustandStore } from "@/zustand-utils"

type EmailScheduleState = {
  scheduledAt: string | null
  schedulingMode: boolean
  sentScheduledAt: string | null
  sentSubject: string | null
}

const initialState: EmailScheduleState = {
  scheduledAt: null,
  schedulingMode: false,
  sentScheduledAt: null,
  sentSubject: null,
}

export const {
  store: emailScheduleStore,
  set,
  useStoreWithSelector: useEmailScheduleStore,
} = defineZustandStore({ initialState, storeName: "EmailSchedule" })

export const EmailScheduleActions = {
  setScheduledAt: (scheduledAt: string | null) =>
    set(scheduledAt ? { scheduledAt, schedulingMode: true } : { scheduledAt }),
  setSchedulingMode: (schedulingMode: boolean) => set({ schedulingMode }),
  clearSelection: () => set({ scheduledAt: null, schedulingMode: false }),
  setSubmitted: (scheduledAt: string | null, subject: string | null) =>
    set({ sentScheduledAt: scheduledAt, sentSubject: scheduledAt ? subject : null }),
  reset: () => set({ ...initialState }),
} as const
